import React from "react";

const RestockBatchesIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.23755 18.0155C2.23755 18.9322 3.05522 19.6759 4.0663 19.6759H15.7294C16.7386 19.6759 17.5581 18.9331 17.5581 18.0155V3.05431C17.5581 2.13764 16.7383 1.39453 15.7294 1.39453H4.0663C3.05491 1.39453 2.23755 2.13734 2.23755 3.05431V18.0155Z"
        fill="#D0D1D2"
      />
      <path
        d="M2.23755 16.844C2.23755 17.7606 3.05522 18.5044 4.0663 18.5044H15.7294C16.7386 18.5044 17.5581 17.7609 17.5581 16.844V1.88243C17.5584 0.965767 16.7386 0.222656 15.7294 0.222656H4.0663C3.05491 0.222656 2.23755 0.965462 2.23755 1.88243V16.844Z"
        fill="#E7E6E6"
      />
      <path
        d="M15.2529 4.24286H4.87689C4.17808 4.24286 4.17808 3.26172 4.87689 3.26172H15.2529C15.9496 3.26141 15.9496 4.24286 15.2529 4.24286ZM15.2529 6.23447H4.87689C4.17808 6.23447 4.17808 5.25394 4.87689 5.25394H15.2529C15.9496 5.25394 15.9496 6.23447 15.2529 6.23447ZM15.2529 8.27039H4.87689C4.17808 8.27039 4.17808 7.28925 4.87689 7.28925H15.2529C15.9496 7.28925 15.9496 8.27039 15.2529 8.27039ZM15.2529 10.2623H4.87689C4.17808 10.2623 4.17808 9.28086 4.87689 9.28086H15.2529C15.9496 9.28086 15.9496 10.2623 15.2529 10.2623ZM15.2529 14.1065H10.4768C9.78105 14.1065 9.78105 13.1254 10.4768 13.1254H15.2529C15.9496 13.1257 15.9496 14.1065 15.2529 14.1065Z"
        fill="#35494D"
      />
      <path
        d="M7.26419 15.4064C7.48385 14.6931 7.84305 13.3493 8.05354 12.8377C8.22364 12.4249 8.38253 12.01 8.57774 11.8144C8.77296 11.6189 9.105 11.6345 9.3053 11.8341C9.3053 11.8341 10.1435 12.4028 10.444 12.779C10.8202 13.0784 11.3895 13.9187 11.3895 13.9187C11.5898 14.119 11.6051 14.4507 11.4099 14.6462C11.2143 14.8415 10.7995 15.0004 10.3863 15.1704C9.87499 15.3809 8.53089 15.7395 7.81759 15.9598C7.6957 15.9971 7.22685 15.5283 7.26419 15.4064Z"
        fill="#D99E82"
      />
      <path
        d="M14.5902 5.80154C14.4973 5.89442 14.4236 6.0047 14.3733 6.12607C14.323 6.24744 14.2971 6.37753 14.2971 6.5089C14.2971 6.64028 14.323 6.77037 14.3733 6.89174C14.4236 7.01311 14.4973 7.12338 14.5902 7.21627L16.0049 8.63133C16.1927 8.81864 16.447 8.92384 16.7123 8.92384C16.9775 8.92384 17.2319 8.81864 17.4196 8.63133L18.8347 7.21627C19.022 7.02851 19.1272 6.77412 19.1272 6.5089C19.1272 6.24369 19.022 5.9893 18.8347 5.80154L17.42 4.38682C17.3271 4.29391 17.2168 4.2202 17.0954 4.16992C16.9741 4.11963 16.844 4.09375 16.7126 4.09375C16.5812 4.09375 16.4511 4.11963 16.3298 4.16992C16.2084 4.2202 16.0981 4.29391 16.0052 4.38682L14.5902 5.80154Z"
        fill="#EA596E"
      />
      <path
        d="M8.57774 11.8129L9.99348 13.2287L11.4068 14.6427L16.7126 9.33726L13.8829 6.50781L8.57774 11.8129Z"
        fill="#FFCC4D"
      />
      <path
        d="M8.33154 15.8037C8.33154 15.8037 7.41182 16.3093 7.1633 16.0607C6.91478 15.8122 7.42302 14.8945 7.42302 14.8945C7.42302 14.8945 8.2942 14.9108 8.33154 15.8037Z"
        fill="#292F33"
      />
      <path
        d="M18.481 7.57197L15.6512 4.74219L13.883 6.51067L16.7125 9.34046L18.481 7.57197Z"
        fill="#CCD6DD"
      />
      <path
        d="M18.1272 7.92319L15.2978 5.09375L14.944 5.44752L17.7734 8.27696L18.1272 7.92319ZM17.42 8.6314L14.5902 5.80162L14.2365 6.15539L17.0662 8.98483L17.42 8.6314Z"
        fill="#99AAB5"
      />
    </svg>
  );
};

export default RestockBatchesIcon;
